import { useEffect, useState } from 'react';
import axios from 'axios';
import { ShoppingBag, Tag, ArrowRight } from 'lucide-react';
import { useMarketplaceWS } from '@/hooks/useLaunchpadWS';
import { BACKEND } from '@/lib/api';

function relTime(iso) {
  if (!iso) return '';
  const ms = new Date() - new Date(iso);
  const s = Math.max(0, Math.floor(ms / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export default function MarketplaceFeed() {
  const [trades, setTrades] = useState([]);

  const load = async () => {
    try {
      const r = await axios.get(`${BACKEND}/api/referral_rewards/marketplace/recent_trades?limit=12`);
      setTrades(r.data.trades || []);
    } catch { /* silent */ }
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  useMarketplaceWS(() => load());

  if (trades.length === 0) return null;

  return (
    <div className="border-y border-[#2B3139] bg-[#181A20] overflow-hidden" data-testid="marketplace-feed">
      <div className="max-w-[1440px] mx-auto flex items-center gap-4 px-4 sm:px-6 py-2.5">
        <div className="hidden sm:flex items-center gap-1.5 shrink-0 text-xs font-mono uppercase text-[#FCD535]">
          <ShoppingBag className="w-3.5 h-3.5" /> Perk Marketplace · Live
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div className="flex gap-6 animate-scroll-x hover:pause-scroll">
            {[...trades, ...trades].map((t, i) => (
              <div key={`${t.listing_id}-${i}`} className="flex items-center gap-2 text-xs whitespace-nowrap shrink-0" data-testid={`feed-item-${i}`}>
                {t.status === 'sold' ? (
                  <>
                    <span className="text-[#0ECB81] font-mono font-semibold">SOLD</span>
                    <Tag className="w-3 h-3 text-[#0ECB81]" />
                    <span className="text-white">{t.perk_name}</span>
                    <span className="text-[#848E9C]">→</span>
                    <span className="text-[#B7BDC6]">{t.buyer_name || 'Anon'}</span>
                    <span className="text-[#FCD535] font-mono">{t.ask_points.toFixed(0)} pts</span>
                  </>
                ) : (
                  <>
                    <span className="text-[#FCD535] font-mono font-semibold">NEW</span>
                    <Tag className="w-3 h-3 text-[#FCD535]" />
                    <span className="text-white">{t.perk_name}</span>
                    <span className="text-[#848E9C]">by</span>
                    <span className="text-[#B7BDC6]">{t.seller_name}</span>
                    <span className="text-[#FCD535] font-mono">{t.ask_points.toFixed(0)} pts</span>
                  </>
                )}
                <span className="text-[#5E6673] font-mono text-[10px]">· {relTime(t.ts)}</span>
              </div>
            ))}
          </div>
        </div>
        <a href="/referrals" className="hidden md:flex items-center gap-1 text-xs text-[#FCD535] hover:text-white shrink-0" data-testid="feed-cta">
          Trade perks <ArrowRight className="w-3 h-3" />
        </a>
      </div>
      <style>{`
        @keyframes scroll-x { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .animate-scroll-x { animation: scroll-x 40s linear infinite; }
        .hover\\:pause-scroll:hover { animation-play-state: paused; }
      `}</style>
    </div>
  );
}
